import { render, staticRenderFns } from "./YouTubeImage.vue?vue&type=template&id=12ad1f70&scoped=true"
import script from "./YouTubeImage.vue?vue&type=script&lang=js"
export * from "./YouTubeImage.vue?vue&type=script&lang=js"
import style0 from "./YouTubeImage.vue?vue&type=style&index=0&id=12ad1f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ad1f70",
  null
  
)

export default component.exports